import { createUseStyles } from 'react-jss'

import { bigBorderRadius, zIndex8, zIndex10 } from '../../styles/const/common'
import { darkGrey, lightGrey } from '../../styles/const/colors'
import { smallPhonesDown } from '../../styles/const/breakpoints'

const useStyles = createUseStyles({
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: showHeader => (showHeader ? zIndex8 : zIndex10),
    backgroundColor: 'rgba(0, 0, 0, .5)',
    color: darkGrey
  },
  modal: {
    overflow: 'auto',
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: 574,
    padding: 45,
    border: `1px solid ${lightGrey}`,
    background: 'rgb(255, 255, 255)',
    borderRadius: bigBorderRadius,
    outline: 'none',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center'
  },
  [`@media screen and (${smallPhonesDown})`]: {
    modal: {
      width: 'calc(100% - 48px)',
      padding: 20
    }
  }
})

export default useStyles
